export enum FilterUsersActiveToday {
    NoMatter = 'noMatterActivity',
    ActiveToday = 'activeToday',
    InactiveToday = 'inactiveToday',
}
